import type { Playbook } from '@squadlab/contracts';

/**
 * Document-renewal playbook v1 (ADR 0052; gov-compliance function). Opened
 * AUTOMATICALLY by the compliance watchdog when a tracked document enters its
 * lead window — the agent drafts the renewal plan (Muqeem/Absher/insurer
 * steps), the operator acknowledges at the gate, and the record-update marks
 * the watch handled. Live government integrations are backlog N3.
 */
export const DOC_RENEWAL_PLAYBOOK: Playbook = {
  key: 'doc-renewal',
  version: 1,
  function: 'gov-compliance',
  title: 'Document renewal',
  steps: [
    {
      id: 'draft-plan',
      kind: 'agent-draft',
      title: 'Draft the renewal plan',
      instruction:
        'Author the step-by-step renewal plan for the expiring document (platform, fees, dependencies, deadline).',
    },
    {
      id: 'gate-ack',
      kind: 'human-gate',
      title: 'Operator acknowledgement of the renewal plan',
      instruction: 'Approve to start executing the plan, request a redo, or reject if the watch is a false alarm.',
    },
    {
      id: 'record-handled',
      kind: 'record-update',
      title: 'Mark the renewal as being handled',
    },
  ],
};
